import { render } from "./TextFront.vue?vue&type=template&id=b637fbc2&scoped=true"
import script from "./TextFront.vue?vue&type=script&lang=js"
export * from "./TextFront.vue?vue&type=script&lang=js"

import "./TextFront.vue?vue&type=style&index=0&id=b637fbc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b637fbc2"]])

export default __exports__